import { useAccount } from '@/account/useAccount';
import { useAppConfigContext } from '@/context/AppConfig';
import { useReportRedirect } from '@/reports/useReportRedirect/useReportRedirect';
import { Grid, styled, Text, Card, Button } from '@/theme/index';

type PropTypes = {
  icon: JSX.Element;
};

const StyledText = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: `${theme.spacing(1)}`,
    width: '100%',
  },
}));

export const PersonReportCTA = ({ icon }: PropTypes) => {
  const { data } = useAccount(true);
  const { trackEvent } = useAppConfigContext();

  const { redirectToSearchPersonUrl } = useReportRedirect();

  const currentUserInfo = data?.account?.user_info;

  const onCTAClick = () => {
    trackEvent('name monitor', 'navigation click', 'identity hub');
    const personInfo = {
      fName: currentUserInfo?.first_name || '',
      lName: currentUserInfo?.last_name || '',
      mName: '',
      age: '',
      city: '',
      state: '',
    };
    redirectToSearchPersonUrl(personInfo);
  };

  return (
    <Card
      variant="outlined"
      sx={{ padding: '12px', marginBottom: '25px' }}
      data-testid="claim-person-cta-container"
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid container item xs={12} sm={9} lg={10} alignItems="center">
          <Grid
            container
            item
            xs={12}
            sm={2}
            lg={1}
            justifyContent="center"
            marginRight={1}
            data-testid="claim-person-icon"
          >
            {icon}
          </Grid>
          <Grid item xs={12} sm={9} lg={10}>
            <StyledText variant="h5">Search for your own report</StyledText>
            <StyledText
              variant="body2"
              fontSize={14}
              data-testid="claim-person-body"
            >
              Claiming your own report is the first step towards identity
              monitoring
            </StyledText>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3} lg={2} sx={{ textAlign: 'end' }}>
          <StyledButton
            variant="contained"
            onClick={onCTAClick}
            data-testid="claim-person-cta"
            color="success"
          >
            + Add
          </StyledButton>
        </Grid>
      </Grid>
    </Card>
  );
};
